/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Manager_Save_PermissionsInputs */

const en_knp_manager_save_permissions = /** @type {(inputs: Knp_Manager_Save_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Permissions`)
};

const fr_knp_manager_save_permissions = /** @type {(inputs: Knp_Manager_Save_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer les autorisations`)
};

const de_knp_manager_save_permissions = /** @type {(inputs: Knp_Manager_Save_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechtigungen speichern`)
};

const it_knp_manager_save_permissions = /** @type {(inputs: Knp_Manager_Save_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva autorizzazioni`)
};

const ru_knp_manager_save_permissions = /** @type {(inputs: Knp_Manager_Save_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранить разрешения`)
};

const es_knp_manager_save_permissions = /** @type {(inputs: Knp_Manager_Save_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar permisos`)
};

const zh_cn2_knp_manager_save_permissions = /** @type {(inputs: Knp_Manager_Save_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存权限`)
};

const ja_knp_manager_save_permissions = /** @type {(inputs: Knp_Manager_Save_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存権限`)
};

const hi_knp_manager_save_permissions = /** @type {(inputs: Knp_Manager_Save_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुमतियाँ सहेजें`)
};

const pt_pt2_knp_manager_save_permissions = /** @type {(inputs: Knp_Manager_Save_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar permissões`)
};

/**
* | output |
* | --- |
* | "Save Permissions" |
*
* @param {Knp_Manager_Save_PermissionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager_save_permissions = /** @type {((inputs?: Knp_Manager_Save_PermissionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Manager_Save_PermissionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_manager_save_permissions(inputs)
	if (locale === "de") return de_knp_manager_save_permissions(inputs)
	if (locale === "it") return it_knp_manager_save_permissions(inputs)
	if (locale === "ru") return ru_knp_manager_save_permissions(inputs)
	if (locale === "es") return es_knp_manager_save_permissions(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_manager_save_permissions(inputs)
	if (locale === "ja") return ja_knp_manager_save_permissions(inputs)
	if (locale === "hi") return hi_knp_manager_save_permissions(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_manager_save_permissions(inputs)
	return en_knp_manager_save_permissions(inputs)
});